var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 228,
    viewBox: "0 0 222 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.002 171.658C142.737 171.658 168.464 145.237 168.464 112.644C168.464 80.0505 142.737 53.6286 111.002 53.6286C79.2666 53.6286 53.54 80.0505 53.54 112.644C53.54 145.237 79.2666 171.658 111.002 171.658Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.404 77.8351L113.439 122.988C112.91 123.532 111.415 124.561 111.002 124.561C110.59 124.561 109.986 124.447 109.457 123.904L88.6587 102.543C84.3097 98.077 77.7045 98.077 73.3555 102.543C69.0065 107.01 68.5607 113.336 72.9098 117.802L123.896 170.166C149.423 164.155 168.464 140.684 168.464 112.644C168.464 99.6252 164.356 87.5939 157.404 77.8351Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 146.52C104.467 146.52 98.325 143.907 93.7056 139.163L72.9073 117.803C68.5583 113.336 68.5583 106.095 72.9073 101.628C77.2559 97.1619 84.3068 97.1619 88.6562 101.628L109.455 122.989C109.984 123.532 110.587 123.646 111 123.646C111.413 123.646 112.016 123.532 112.545 122.989L167.695 66.3479C172.044 61.8818 179.095 61.8818 183.444 66.3479C187.793 70.8145 187.793 78.056 183.444 82.5225L128.294 139.163C123.675 143.907 117.533 146.52 111 146.52Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 84.2753,
    y1: 85.195,
    x2: 141.137,
    y2: 140.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9B6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 163.232,
    y1: 147.193,
    x2: 142.087,
    y2: 126.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 105.943,
    y1: 69.2409,
    x2: 164.836,
    y2: 126.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DFE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.426edc9decd33115a2799e8817c3d2ed.svg";
export { ForwardRef as ReactComponent };